type ValueOf<T> = T[keyof T];

export const FEATURED_SECTIONS = {
  NEW_PRODUCTS: 'new-products',
  TWIC_PICKS: 'twic-picks',
  NO_COST: 'no-out-of-pocket-cost',
  POPULAR: 'popular',
  UNPOPULAR: 'unpopular',
} as const;

export type FeaturedSection = ValueOf<typeof FEATURED_SECTIONS>;
